import { GraphqlQueryResponse } from "@/Common/api/types/GraphqlQueryResponse";
import { IMyCIT } from "@/Common/types/MyCit/model";
import { apiInstance, gql } from "@/services/httpAdapter";
import { errorLogger } from "@Common/helpers/logger";

export async function getMyCit(locationId: string, commissionCycleId: string, payPeriodId: string, userId: string) {
	const query = gql`
		query getMyCit($locationId: String!, $commissionCycleId: String!, $payPeriodId: String!, $userId: String!) {
			getMyCit(locationId: $locationId, commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId, userId: $userId) {
				_id
				commissionCycleId
				locationId
				deals {
					_id
					age
					balance
					amountFinanced
					creationDate
					customerName
					customerNumber
					date
					dealNumber
					dealStatus
					financeEmployee
					financeEmployeeId
					funded
					isUpdatedByCIT
					lender
					salesEmployee
					salesEmployeeId
					salesManager
					salesManagerEmployeeId
					stockNumber
					trade
					vinNumber
				}
				analytics {
					age
					amount
					quantity
				}
				lastModifiedOn
			}
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		payPeriodId,
		userId,
	};

	try {
		const response: GraphqlQueryResponse<"getMyCit", IMyCIT> = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getMyCit;
	} catch (err) {
		errorLogger(err as Error, { function: "getMyCit", message: "Error getting my CIT", variables });
		return null;
	}
}
